export enum UserRole {
  APPLICANT = 'APPLICANT',
  SCOUT = 'SCOUT',
  ADMIN = 'ADMIN',
  FINANCE = 'FINANCE',
  AUDITOR = 'AUDITOR',
}

export type RolePermissions = {
  [UserRole.APPLICANT]: {
    canRegister: true
    canLogin: true
    canDownloadScript: true
    canUploadVideo: true
    canBookInterview: true
    canReserveBusinesses: false
    canSubmitVisits: false
  }
  [UserRole.SCOUT]: {
    canReserveBusinesses: true
    canSubmitVisits: true
    canUploadPhotos: true
    canTrackCompensation: true
  }
  [UserRole.ADMIN]: {
    canReviewApplicants: true
    canApproveScouts: true
    canManageBusinesses: true
    canManageRegions: true
    canManageCompensation: true
    canManageInterviewAvailability: true
    canConductInterviews: true
  }
  [UserRole.FINANCE]: {
    canReviewCompensation: true
    canApprovePayouts: true
    canExportReports: true
  }
  [UserRole.AUDITOR]: {
    canViewLogs: true
    canViewAuditTrail: true
    canViewCompensation: true
  }
}
